import FormDetails from './FormDetails';

export default FormDetails;
